export const CaseRoutes = {
   
    createCase: "/case/addCase",
    getCases: "/case/getCases",
   deleteCase:"/case/deleteCase",
   updateCase:"/case/updateCase",
   assignCase:"/case/assignedCase",
   getCaseDetail:"/case/getCaseById"
  };
    